import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import {connect, useSelector} from "react-redux";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { ErrorMessage, useForm } from "react-hook-form";

import RoutLangs from "./_langs";
import {
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {
    INTERNATIONAL,
    MAX_NAME,
    REQUIRED
} from "../../../components/i18n/i18n";
import { FL_ALLOWED_TO_BUY, FL_CODE, FL_IMAGE, FL_ORDER, FL_PRIMARY_COLOR, FL_SECONDARY_COLOR, FL_STATUS } from "../../../components/i18n/formLabels";
import {PH_CODE, PH_IMAGE} from "../../../components/i18n/placeHolders";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import {utilHelper} from "../../../jwt/_helpers";
import {routService} from "../../../jwt/_services/clasificator/routService";
import {getCurrentDateForCodeField} from "../../../util/DateTools";

const RoutForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, udn, editMode, domainObject} = componentState?.data;

    // const { dataToEdit, editMode, loading, disableInputs, saveSuccess } = props.admissionState
    const [status, setStatus] = useState(domainObject?.status !== undefined ? domainObject.status : true);
    const [allowBuy, setAllowBuy] = useState(domainObject?.allowBuy !== undefined ? domainObject.allowBuy : true);
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `rout_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
            showOrder: domainObject?.showOrder,
            description: domainObject?.description,
            icon: domainObject?.icon,
            colorHex: domainObject?.colorHex
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase: { id : app?.fbDataBase?.id },
            item: {
                ...data,
                langs: langs,

                colorRgb: utilHelper.hexToRGB(data.colorHex),
                udn: udn,
            }
        };

        if (!editMode)
            genericIndexedActions.save(path, routService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, routService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }

    return  <>
        <Form onSubmit={ handleSubmit(onSubmit) }>
            <Card className={'card-modal-small'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / Rutas / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="code">{'Código'}</Label>
                                <Input type="text" name="code"
                                       placeholder=" Código"
                                       innerRef={register}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="icon">{'Ícono'}</Label>
                                <Input type="text" name="icon"
                                       placeholder="Icono"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label htmlFor="color">{'Color'}</Label>
                                <Input type="color" name="colorHex"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label htmlFor="status">{'Activo'}</Label><br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className={'form-container'}>
                        <div className={''}>
                            <h2> {INTERNATIONAL}</h2>
                        </div>
                        <div className={''}>
                            <Row>
                                <Col>
                                    <RoutLangs
                                        langs={langs}
                                        setLangs={setlangs}
                                        translatableLangs={translatableLangs}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Form>

        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
})

export default connect(mapStateToProps, mapActionsToProps)(RoutForm)